import { useMemo } from 'react'
import { useAppSelector } from 'src/store/hooks'
import { selectLinkedServices } from '../manage.slice'

export function useLinkedServiceName(
  linkedServiceID: string | undefined,
): string {
  let linkedServices = useAppSelector(selectLinkedServices)

  return useMemo(() => {
    if (!linkedServiceID) return 'Unknown Linked Service'

    let linkedService = linkedServices.find((ls) => ls.id === linkedServiceID)
    return linkedService?.name || 'Unknown Linked Service'
  }, [linkedServiceID, linkedServices])
}
